module.exports = __webpack_public_path__ + "static/media/help-icon.fbaaf079.svg";